import { Failure } from '@mrhenry/failure';
import { staticText } from '../static-text';
import { WPHousePosts } from '../types/wp-data';

export async function getWPHousePostsWithAllowNewReservations( posts: WPHousePosts ): Promise<WPHousePosts | Failure> {
	let properties: Record<string, {
		allowNewReservations: boolean
	}>;

	const subQueries = posts.map( ( post ) => {
		return `house_${post.id}:property(id: "${post.id}") {
			allowNewReservations
		}`;
	} ).join( '\n' );

	try {
		const endpoint = new URL( '/graphql', 'https://' + window.Mr.theaddressesApiDomain );
		const response = await fetch( endpoint, {
			credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify( {
				query: `{ ${subQueries} }`,
			} ),
		} );

		if ( !response.ok ) {
			console.error( 'Error:', `${response.status}: ${response.statusText}` );

			return Failure.from( staticText.fetchingPropertiesDateFailureMessage );
		}

		const data = await response.json();
		if ( data?.errors?.length ) {
			console.error( 'Error:', data.errors );

			return Failure.from( staticText.fetchingPropertiesDateFailureMessage );
		}

		properties = data.data;
	} catch ( error ) {
		console.error( error );

		return Failure.from( staticText.fetchingPropertiesDateFailureMessage );
	}

	if ( !properties ) {
		throw new Error( '"data" field expected in every API response, got a falsy value instead' );
	}

	const out = [];
	for ( const post of posts ) {
		if ( !( `house_${post.id}` in properties ) ) {
			throw new Error( `House Post Id (${post.id}) cannot be found inside the properties from the api.` );
		}

		out.push( {
			...post,
			allowNewReservations: properties[`house_${post.id}`].allowNewReservations,
		} );
	}

	return out;
}
